import { render, staticRenderFns } from "./ModalGridColumns.vue?vue&type=template&id=d81bd854&scoped=true&"
import script from "./ModalGridColumns.vue?vue&type=script&lang=js&"
export * from "./ModalGridColumns.vue?vue&type=script&lang=js&"
import style0 from "./ModalGridColumns.vue?vue&type=style&index=0&id=d81bd854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81bd854",
  null
  
)

export default component.exports